import {
  PatientHaudyDetailPage as Component,
  PatientHaudyDetailPageProps,
} from "../../../components/pages/patientHaudy/PatientHaudyDetailPage";
import { useCheckUserRole, useHandleError } from "../../../hooks";
import { useParams } from "react-router";
import { GQLQuery } from "@rx-cs-system/schema";
import { useQuery } from "@apollo/client/react";
import { GET_HAUDY_USER } from "../../../graphql/queries";
import { parsePatientHaudy } from "../../../graphql/utils";

export const PatientHaudyDetailPage = ({}) => {
  useCheckUserRole();

  const { id: patientId } = useParams<{ id: string }>();
  if (!patientId) throw new Error("patientId is undefined");

  const { error, data } = useQuery<GQLQuery>(GET_HAUDY_USER, {
    variables: {
      id: patientId,
    },
  });
  useHandleError(error);

  if (!data?.haudyUser) {
    return null;
  }
  const haudyUser = data.haudyUser;

  const props: PatientHaudyDetailPageProps = {
    patientHaudy: parsePatientHaudy(haudyUser),
  };

  return <Component {...props} />;
};
